import { render, staticRenderFns } from "./DialogOneStage.vue?vue&type=template&id=5447dcff&scoped=true"
import script from "./DialogOneStage.vue?vue&type=script&lang=js"
export * from "./DialogOneStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5447dcff",
  null
  
)

export default component.exports